import cx from "classnames";
import { useCallback, useState } from "react";

import "./CollapsingCard.css";
import { StyledButtonContainer } from "./StyledButtonContainer";

type MenuDirection = "up" | "down" | "left" | "right";

// The use of PropsWithChildren here is potentially confusing but I think
// it's a good habit to get into, even though we're accepting children
// in multiple fields.
export type CollapsingCardProps = React.PropsWithChildren<{
  icon: React.ReactNode;
  tooltip: React.ReactNode;
  // NOTE: up is the default
  direction?: MenuDirection;
  // for contolled open state
  open?: boolean;
  onToggle?: () => void;
}>;

export function CollapsingCard(props: CollapsingCardProps) {
  const { children, icon, tooltip, direction = "up", open, onToggle } = props;

  const [collapsed, setCollapsed] = useState<boolean>(true);
  const isOpen = open ?? !collapsed;

  const onClick = useCallback(() => {
    if (onToggle) onToggle();
    else setCollapsed((v) => !v);
  }, [onToggle]);

  const scaleAxis =
    direction === "left" || direction === "right" ? "scaleX" : "scaleY";

  return (
    <div className="collapsing-card-container">
      <StyledButtonContainer
        className="collapsing-card-display"
        onClick={onClick}
        showPip
        pipDirection={direction}
        showIndicator
        selected={isOpen}
        indicatorLit={isOpen}
      >
        {icon}
        {tooltip}
      </StyledButtonContainer>
      <div
        className={cx("collapsing-card-menu", direction)}
        style={{
          opacity: isOpen ? 1 : 0,
          transform: `${scaleAxis}(${isOpen ? 1 : 0})`
        }}
      >
        {children}
      </div>
    </div>
  );
}
